export const environment = import.meta.env.VITE_ENVIRONMENT;
export const baseUrl = import.meta.env.VITE_BASE_URL;

export const auth0Config = {
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  authorizationParams: {
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
  },
};

export const sentryDsn = import.meta.env.VITE_SENTRY_DSN;
